/**
 * This util extracts from a JSON file all texts to translate them
 */

const sample = require('../data/translations-sample.json');

const extractValues = (dataToExtract = sample) => {
  let result = [];

  const objectValues1 = Object.values(dataToExtract);
  objectValues1.forEach((item1) => {
    if (typeof item1 === 'string') {
      return result.push(item1);
    } else if (typeof item1 === 'object') {
      if (Array.isArray(item1)) {
        return item1.forEach((item2) => {
          if (typeof item2 === 'string') {
            result.push(item2);
          } else if (typeof item2 === 'object') {
            if (Array.isArray(item2)) {
              item2.forEach((item3) => result.push(item3));
            } else {
              Object.values(item2).forEach((item3) => result.push(item3));
            }
          }
        });
      } else {
        return Object.values(item1).forEach((item2) => result.push(item2));
      }
    }
  });

  return result;
};

export default extractValues;
